





















































import { Component, Vue } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import store, { StoreReports } from "../store";
import { LivingAppsReportRecord, LivingAppsReportControl } from "../types";
import ReportDetailForm from "@/components/ReportDetailForm.vue";
import { AlertController } from "@ionic/vue/dist/types/controllers";
import { OverlayController, AlertOptions } from "@ionic/core";
import { EventBus } from "@/main";

@Component({
  components: {
    ReportDetailForm
  }
})
export default class Reports extends Vue {
  public storeReports = StoreReports;
  public controls?: LivingAppsReportControl | null;
  public edit: boolean = false;

  public get reports() {
    return this.storeReports.getRecords;
  }

  public getReportById(recordId: string) {
    for (const report of this.storeReports.getRecords) {
      if (report.id === recordId) {
        return report;
      }
    }
    return null;
  }

  public handleClick(route: string, id: string) {
    const rp: any = { name: route, params: { id } };
    this.$router.push(rp);
  }

  public handleControls() {
    this.controls = this.storeReports.getControls;
  }

  public isOfflineItem(recordId: string) {
    if (recordId && recordId.includes("__cached__")) {
      return true;
    }
    return false;
  }

  public saveOfflineItem(recordId: string) {
    EventBus.$emit("saveOfflineItem", this, recordId);
  }

  public saveOfflineItemAction(recordId: string) {
    const record = this.getReportById(recordId);
    if (record) {
      store.dispatch("storeRecordToLivingApps", {
        record,
        app: this,
        eventBus: EventBus
      });
    }
  }

  public deleteCancel(recordId: string) {
    const elm = document.getElementById("record-list") as HTMLIonListElement;
    if (elm) {
      elm.closeSlidingItems();
    }
  }

  public deleteItem(recordId: string) {
    const elm = document.getElementById("record-list") as HTMLIonListElement;
    if (elm) {
      elm.closeSlidingItems();
    }
    store.dispatch("deleteRecordData", {
      recordIds: [recordId],
      app: this,
      eventBus: EventBus
    });
  }

  public deleteAction(recordId: string) {
    EventBus.$emit("deleteListItem", this, recordId);
  }

  public newReport() {
    this.edit = true;
  }

  public formFinish() {
    const refForm: any = this.$refs.reportFormComp;
    if (refForm.isDirty) {
      EventBus.$emit("dirtyForm", this, refForm);
    } else {
      this.edit = false;
    }
  }

  public formCancel() {
    const refForm: any = this.$refs.reportFormComp;
    this.edit = false;
    refForm.isDirty = false;
  }

  public formSaved() {
    const refForm: any = this.$refs.reportFormComp;
    this.edit = false;
    refForm.isDirty = false;
  }

  protected mounted() {
    this.handleControls();
  }
}
